<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-video.svg" can-back-flag="1"></Header>
    </header>

    <!--詳細-->
    <div id="wrapper">
      <div class="content">
        <div class="video-detail-box">
          <h3 class="ttl">{{ title }}</h3>
            <div class="videobox">
                <video id="video" controls playsinline>
                    <source :src="url" type="video/mp4">
                </video>
                <div class="videothum">
                    <img :src="thumbnail">

                    <div class="playbutton">
                        <img src="static/images/video/obj_arrow.svg">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-video")
    $("body").addClass("page-video-detail")
    cmd.adjustStyle()

    var video = document.getElementById('video');
    $('.videothum').on('click', function() {
        $(this).css({ 'animation': 'videoplay_thum 1s' });
        $('.playbutton').css({ 'animation': 'videoplay 1s' });
        video.play();
    });
    $('.playbutton').on('animationend', function () {
        $('.videothum').css({ 'display': 'none' });
    });

  },
  methods: {
    ...mapActions('MovieModule', {
      'prevAction': 'prevAction'
    }),
  },
  computed: {
    ...mapGetters('MovieModule', [
      'thumbnail',
      'title',
      'url'
    ])
  },
  components: {
    Header
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MovieDetail.vue